import React, {Fragment, useState, useRef, useImperativeHandle} from 'react';

import UserInput from "ui/ReactUserInput";
import UserInputCheckbox from "ui/ReactUserInputCheckbox";
import FieldsetContainer from "root/Base/FieldsetContainer";
import BootstrapRow from "ui/BootstrapRow";
import {useChildContext} from "root/Contexts/ChildContext";
import BootstrapCol from "ui/BootstrapCol";
import DropdownEducationStatus from "ui/DropdownEducationStatus";
import DropdownTransitions from "ui/DropdownTransitions";

export const emptyTransitionData = {
   transitioning_flag: 0,
   transition_id: null,
}

const TransitionForm = React.forwardRef(({readOnly, displayErrors, child}, ref) =>
{
   const { isPost16 } = useChildContext();

   const initialIsTransitioning = child.transition_id !== null ;
   const initialTransitionId = child.transition_id === null ? null : +(child.transition_id)  ;

   const [isTransitioning, setIsTransitioning] = useState(initialIsTransitioning)
   const [transition_id, setTransitionId] = useState(initialTransitionId)

   const InputIsTransitioning = useRef(null);
   const InputTransitionType = useRef(null);

   useImperativeHandle(ref, () => ({
      getFormData()
      {
         return getFormDataLocal();
      },
      formIsValid()
      {
         return formIsValidLocal();
      },
   }))

   const getFormDataLocal = () =>
   {
      return (
         {
            transitioning_flag: isTransitioning ? 1 : 0,
            transition_id: isTransitioning ? transition_id : null,
         }
      )
   }

   const formIsValidLocal = () =>
   {
      let valid = true;

      if (isTransitioning)
      {
         if ( transition_id === null )
         {
            valid = false;
         }
      }

      return valid;
   }

   const onChangeTransitionType = (newValue) =>
   {
      setTransitionId(newValue.value);
   }

   const onChangeTransitionFlag = (newValue) =>
   {
      setIsTransitioning(newValue);
   }

   const transitionTypeSection = () =>
   {
      return (
          <Fragment>
             <div key='tranid' className='col-md-12'>
                <DropdownTransitions validation={{required: true}}
                                     key='DropdownTransitions'
                                     onChange={onChangeTransitionType}
                                         value={ initialTransitionId }
                                         readOnly={readOnly}
                                         labelClassName='col-form-label'
                                         label='Select the Transition type' defaultClassName=''/>
                {displayErrors === true && onChangeTransitionFlag === null &&
                    <div className='input-error-visible'>You must select a transition type for this child</div>}
             </div>
          </Fragment>
      )
   }


   const isChildTransitioningSection = () =>
   {
      return (
         <Fragment>
            <div key='tranchk' className='col-md-6'>
               <UserInputCheckbox
                  key='InputIsTransitioning'
                  ref={InputIsTransitioning}
                  label='Is the child transitioning this year'
                  errorText='Is the child transitioning this yearn'
                  defaultValue={initialIsTransitioning}
                  readOnly={readOnly}
                  onChange={onChangeTransitionFlag}
                  displayErrors={displayErrors}/>
            </div>
         </Fragment>
      )
   }

   const transitionFieldset = () =>
   {
      return (
         <FieldsetContainer title='Transition'>
            <BootstrapRow>
               {isChildTransitioningSection()}
               { isTransitioning === true && transitionTypeSection()}
            </BootstrapRow>
         </FieldsetContainer>
      )
   }

      return (
         <BootstrapRow>
            <BootstrapCol width={12}>
               { isPost16 === false && transitionFieldset() }
            </BootstrapCol>
         </BootstrapRow>
      )
})

export default TransitionForm;
